export class ThickenerPumpPara {
    constructor({
        id = ``,
        day = ``,
        time = ``,
        locName = ``,
        locId = ``,
        furnaceNumber = ``,
        thickenerScorpionPressure = ``,
        pumpPressure = ``,
        pumpLiquidLevel = ``,
    }={}){
        this.id = id;
        this.day = day;
        this.time = time;
        this.locName = locName;
        this.locId = locId;
        this.furnaceNumber = furnaceNumber;
        this.thickenerScorpionPressure = thickenerScorpionPressure;
        this.pumpPressure = pumpPressure;
        this.pumpLiquidLevel = pumpLiquidLevel;
    }
}

export function gridFields(){
    return Object.freeze([
        {
            key: 'day',
            label: 'lbl.basic.date',
            sortable: true,
            form: {
              type: 'datepicker'
            }
        },
        {
            key: 'time',
            label: 'lbl.basic.datetime',
            sortable: true,
            form: {
              type: 'timepicker'
            }
        },
        {
          key: 'locName',
          label: 'lbl.fm.locationName',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
            key: 'furnaceNumber',
            label: 'lbl.basic.furnaceName',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'thickenerScorpionPressure',
            label: 'lbl.fm.thickenerScorpionPressure',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'pumpPressure',
            label: 'lbl.fm.pumpPressure',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'pumpLiquidLevel',
            label: 'lbl.fm.pumpLiquidLevel',
            sortable: true,
            form: {
              type: 'input'
            }
        }
    ]);
}

export const fields = Object.freeze(Object.keys(new ThickenerPumpPara()).map(i => 'entity.'+i));

export const filterFields = [
    'filter.startTimeFilter',
    'filter.endTimeFilter',
    'filter.furnaceNumberFilter',
    'filter.locNameFilter',
];

export const filter = {
    'startTimeFilter' : '',
    'endTimeFilter' : '',
    'furnaceNumberFilter' : 'default',
    'locNameFilter' : 'default',
};